import { useEffect, useState } from "react";

/**
 * (Task AN) owner store-app mode: the all-branch dashboard ("hq", default) or the normal store tabs ("store").
 * Kept free of nav.ts imports so the app bundle doesn't split nav.ts (and its web-only route tables) into a shared chunk.
 */
export type OwnerMode = "hq" | "store";
const MODE_KEY = "spos.ownerMode";
export const ownerMode = (): OwnerMode => { try { return localStorage.getItem(MODE_KEY) === "store" ? "store" : "hq"; } catch { return "hq"; } };
export function setOwnerMode(m: OwnerMode) { try { localStorage.setItem(MODE_KEY, m); } catch { /* private mode */ } window.dispatchEvent(new Event("spos-owner-mode")); }

/** re-render when the owner flips between the all-branch dashboard and the store tabs */
export function useOwnerMode(): OwnerMode {
  const [m, setM] = useState<OwnerMode>(ownerMode);
  useEffect(() => { const h = () => setM(ownerMode()); window.addEventListener("spos-owner-mode", h); return () => window.removeEventListener("spos-owner-mode", h); }, []);
  return m;
}

/** the owner dashboard's branch filter: "" = 全部分店 (default) or one branch id */
const KEY = "spos.hqBranch";
export const hqBranch = (): string => { try { return localStorage.getItem(KEY) ?? ""; } catch { return ""; } };
export function setHqBranch(id: string) { try { localStorage.setItem(KEY, id); } catch { /* private mode */ } window.dispatchEvent(new Event("spos-hq-branch")); }
export function useHqBranch(): string {
  const [b, setB] = useState(hqBranch);
  useEffect(() => { const h = () => setB(hqBranch()); window.addEventListener("spos-hq-branch", h); return () => window.removeEventListener("spos-hq-branch", h); }, []);
  return b;
}
